import _flatMap from "lodash/flatMap";
import _groupBy from "lodash/groupBy";
import _pick from "lodash/pick";
import { createSelector } from "reselect";
import { getAllTemplateMetadataById } from "src/store/templateMetadata/selectors";
import { TemplateId } from "../../../globalTypes";
import { getTemplateIdsForModuleId } from "../../modules/selectors";
import { RootState as RS } from "../../types";
import { getNotificationsSlice } from "../selectors";

const passTemplateId = (s: RS, templateId: TemplateId) => templateId;

export const getTemplateNotificationsSlice = (s: RS) =>
  getNotificationsSlice(s).template;

export const getTemplateNotificationsFetchStatus = (s: RS) =>
  getTemplateNotificationsSlice(s).fetchStatus;

export const getTemplateNotificationMessages = (s: RS) =>
  getTemplateNotificationsSlice(s).messages;

export const getNotificationsByTemplateId = createSelector(
  getTemplateNotificationMessages,
  (messages) => _groupBy(messages, "overviewTemplateId")
);

export const getIdsOfTemplatesWithActiveNotifications = createSelector(
  getNotificationsByTemplateId,
  (messages) => Object.keys(messages).map(Number)
);

export const makeGetNotificationsForTemplate = () =>
  createSelector(
    getNotificationsByTemplateId,
    passTemplateId,
    (messages, templateId) => messages[templateId] ?? []
  );

export const makeGetNotificationRowKeysForTemplate = () =>
  createSelector(
    makeGetNotificationsForTemplate(), // I <3 PRETTIER
    (messages) => messages.map((n) => n.recordPrimaryKey)
  );

export const getNotificationsForModule = createSelector(
  getNotificationsByTemplateId,
  getTemplateIdsForModuleId,
  (messagesByTemplateId, templateIds) => {
    if (!templateIds) return [];
    const onlyRelevantTemplatesDict = _pick(
      messagesByTemplateId,
      templateIds.map(({ id }) => id)
    );
    return _flatMap(onlyRelevantTemplatesDict);
  }
);

export const getTemplateNonTaskNotificationMessages = createSelector(
  getTemplateNotificationMessages,
  (messages) => messages.filter((message) => !message.notificationIsTask)
);

export const getMissingTemplateIdsForNotifications = createSelector(
  getIdsOfTemplatesWithActiveNotifications,
  getAllTemplateMetadataById,
  (templateIds, templatesMetadata) =>
    templateIds.filter((templateId) => !templatesMetadata[templateId])
);
